import { Alert, Box, Button, ButtonGroup, Chip, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, InputLabel, ListItemText, Menu, MenuItem, Select, Snackbar, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import { IFacturaCompleta } from "../facturarCita/DetalleFacturaComplementaria";
import IPaciente from "../../../types/Paciente";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as constantes from "../../../common/Constantes";
import ConfigUtils from "../../../utils/Config";
import moment from "moment";
import IAlert from "../../../types/Alert";
import DownloadIcon from '@mui/icons-material/GetApp';
import EmailIcon from '@mui/icons-material/Email';
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
import PacientesUtils from "../../../utils/Pacientes";
import { IConcepto } from "../facturarCita/DetalleFactura";
import React from "react";
import MoreIcon from '@mui/icons-material/MoreVert';
import DocUtils from "../../../utils/Doc";
import FacturacionService from "../../../services/FacturacionService";
import LogService from "../../../services/LogService";
import ILog from "../../../types/Log";
import EditarFacturaClaseForm from "./EditarFacturaClaseForm";
import { EstadoFacturacionClase } from "./FacturacionMes";
import { IFacturaMetodoPago } from "../facturarCita/FacturarCitaDialog";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import RectificarFacturaClase from "./RectificarFacturaClase";
import { formatCurrency, formatNumeroFactura } from "../../../utils/Factura";
import CambiarEntidadDialog from "../common/CambiarEntidadDialog";
import { getFacturaAcciones } from "../common/facturaAcciones";
import NumeroOrientativoEmision, { cargarNumeroOrientativo, InfoNumeroOrientativo } from "../common/NumeroOrientativoEmision";
import AnularFacturaDialog from "../common/AnularFacturaDialog";
import { chipEstadoFactura, chipEstadoPago } from "../common/chipsEstadoFactura";
import EliminarFacturaAnulada, { AvisoEliminacion } from "../common/EliminarFacturaAnulada";
import EnlaceFactura from "../common/EnlaceFactura";

interface DetalleFacturaClaseProps {
  open: boolean;
  onClose: () => void;
  facturaId: string;
  factura?: IFacturaCompleta | null;
  paciente?: IPaciente;
  actividadId?: number;
  periodo?: string;
  motivoNoFacturable?: string;
  facturable: boolean;
  onEdit?: (pacienteId: string, actividadId: number, factura: IFacturaCompleta, estado: EstadoFacturacionClase, motivo: string, periodo?: string) => void;
  onFacturaPagada?: (pacienteId: string, actividadId: number, id: string, fechaPago: string | null | undefined, estado: string, estadoPago: string, periodo?: string) => void;
  onFacturaEmitida?: (pacienteId: string, actividadId: number, id: string, estado: string, estadoPago: string, periodo?: string, numero?: string) => void;
  onUpdateMotivo?: (pacienteId: string, actividadId: number, motivo: string, periodo?: string) => void;
  onFacturar?: (pacienteId: string, actividadId: number, periodo: string) => void;
  onFacturaRectificada?: (pacienteId: string, actividadId: number, factura: IFacturaCompleta, periodo?: string) => void;
  onAnularFactura?: (pacienteId: string, actividadId: number, periodo: string, _id: string, motivoAnulacion: string, anulacion?: IFacturaCompleta) => void;
  onFacturaEliminada?: (pacienteId: string, actividadId: number, periodo: string, _id: string, aviso: AvisoEliminacion) => void;
  // La factura había cambiado de estado en otra pantalla: se ha vuelto a cargar y se informa de su estado actual.
  onEstadoCambiado?: (pacienteId: string, actividadId: number, periodo: string, factura: IFacturaCompleta) => void;
  onEntidadCambiada?: (pacienteId: string, actividadId: number, periodo: string, facturaAnuladaId: string, facturaNueva: IFacturaCompleta, anulacion?: IFacturaCompleta | null) => void;
}

const DetalleFacturaClase = ({ open, onClose, facturaId, factura, paciente, actividadId, periodo, motivoNoFacturable, facturable, onEdit, onFacturaPagada, onFacturaEmitida, onUpdateMotivo, onFacturar, onFacturaRectificada, onAnularFactura, onEntidadCambiada, onFacturaEliminada, onEstadoCambiado }: DetalleFacturaClaseProps) => {
    const history = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [alert, setAlert] = useState<IAlert>({ open: false, severity: "info", msg: "" });
    const handleCloseAlert = () => setAlert({ open: false, severity: "info", msg: "" });
    const [loading, setLoading] = useState(false);
    const [showMissingAlert, setShowMissingAlert] = useState(true);
    const [loadingEnviar, setLoadingEnviar] = useState(false);
    const [modalPagar, setModalPagar] = useState(false);
    const [loadingPagar, setLoadingPagar] = useState(false);
    const [metodoPago, setMetodoPago] = useState<IFacturaMetodoPago | undefined>(undefined);
    const [errorMetodoPago, setErrorMetodoPago] = useState<string | undefined>(undefined);
    const [errorFechaPago, setErrorFechaPago] = useState<string | undefined>(undefined);
    const [loadingEmitir, setLoadingEmitir] = useState(false);
    const [modalEmitir, setModalEmitir] = useState(false);
    const [numeroOrientativo, setNumeroOrientativo] = useState<InfoNumeroOrientativo | null>(null);
    const [erroresPaciente, setErroresPaciente] = useState<string[]>([]);
    const [expandirDetalle, setExpandirDetalle] = useState(false);
    const [modalMotivo, setModalMotivo] = useState(false);
    const [loadingMotivo, setLoadingMotivo] = useState(false);

    const [localFactura, setLocalFactura] = useState(factura);
    const monedaFactura = localFactura?.moneda || 'EUR';
    const acciones = getFacturaAcciones({ ...(localFactura ?? {}), tieneOpcionAnular: true });
    const [localPaciente, setLocalPaciente] = useState(paciente);
    const [localActividadId, setLocalActividadId] = useState(actividadId);
    const [localPeriodo, setLocalPeriodo] = useState(periodo);
    const [modalEditarFactura, setModalEditarFactura] = useState(false);
    const [localMotivo, setLocalMotivo] = useState(motivoNoFacturable);

    const [isFacturable, setIsFacturable] = useState(facturable);
    const [openFacturaInfo, setOpenFacturaInfo] = useState(false);
    const [infoMessage, setInfoMessage] = useState("");

    const [facturaRectificar, setFacturaRectificar] = useState<IFacturaCompleta | null>(null);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [modalAnular, setModalAnular] = useState(false);
    const [loadingAnular, setLoadingAnular] = useState(false);
    const [motivoAnulacion, setMotivoAnulacion] = useState("");
    const [confirmarAnulacion, setConfirmarAnulacion] = useState(false);

    const [modalCambiarEntidad, setModalCambiarEntidad] = useState(false);
    const [loadingCambiarEntidad, setLoadingCambiarEntidad] = useState(false);

    const metodosPago = ConfigUtils.getMetodosPago();
    const actividades = ConfigUtils.getActividades();
    const userRole: number = ConfigUtils.getUserRole();

    useEffect(() => {
      if (localFactura === null || !localPaciente || !localActividadId || !localPeriodo) load();
    }, []);

    useEffect(() => {
      setIsFacturable(facturable);
    }, [facturable]);

    const load = async () => {
      try {
          setLoading(true);
          if (!facturaId) return;
          const response = await FacturacionService.getFacturaClaseById(facturaId);
          setLocalFactura(response.data.factura);
          setLocalPaciente(response.data.paciente);
          setLocalActividadId(response.data.actividadId);
          setLocalPeriodo(response.data.periodo);
      }  catch (e: any) {
        if (e.response?.status === 401) {
          localStorage.clear();
          history(constantes.R_HOME);
        } else {
          const error: ILog = {
            method: "DetalleFacturaClase.Component.load",
            level: "error",
            message: e.message,
            meta: e.response,
          };
          LogService.logError(error);
          setAlert({ open: true, severity: "error", msg: e.response?.data?.message || e.message });
        }
      } finally {
        setLoading(false);
      }
    };

    const openModalPagar = () => {
      if (localFactura?.estadoPago === "Pagada" && localFactura.metodoPago) {
        setMetodoPago({
          nombre: localFactura.metodoPago.nombre,
          codigo: localFactura.metodoPago.codigo,
          fechaPago: moment(localFactura.metodoPago.fechaPago),
        });
      }
      setModalPagar(true);
    };

    const openModalEmitir = async () => {
      const errores: string[] = [];

      if (localFactura && !localFactura.receptor?.nombre) errores.push("Nombre");
      if (localFactura && !localFactura.receptor?.nif) errores.push("DNI");
      if (!localPaciente?.fechaNacimiento) errores.push("Fecha de nacimiento");

      if (errores.length > 0) {
        setErroresPaciente(errores);
      }
      setNumeroOrientativo(errores.length === 0 ? await cargarNumeroOrientativo(localFactura?._id) : null);
      setModalEmitir(true);
    };

    const closeModalPagar = () => {
      setMetodoPago(undefined);
      setErrorMetodoPago(undefined);
      setErrorFechaPago(undefined);
      setModalPagar(false);
    };

    const closeModalEmitir = () => {
      setErroresPaciente([]);
      setModalEmitir(false);
    };

    const closeModalMotivo = () => {
      setModalMotivo(false);
      setLocalMotivo(motivoNoFacturable || "");
    };

    const pagarFactura = async () => {
      let hasError = false;

      if (!metodoPago) {
        setErrorMetodoPago("Debes seleccionar un método de pago");
        hasError = true;
      }
      if (!metodoPago?.fechaPago) {
        setErrorFechaPago("Debes seleccionar una fecha de pago");
        hasError = true;
      } else if (!moment.isMoment(metodoPago.fechaPago) || !metodoPago.fechaPago.isValid()) {
        setErrorFechaPago("Debes seleccionar una fecha de pago válida");
        hasError = true;
      }

      if (hasError) return;
      if (!metodoPago) return;

      setErrorMetodoPago(undefined);
      setErrorFechaPago(undefined);

      try {
        setLoadingPagar(true);
        const response = await FacturacionService.pagarFactura(localFactura?._id!, { 
          tipoPago: "clase",
          metodoPago });

        setLocalFactura(prev => ({
          ...prev!,
          estadoPago: "Pagada",
          metodoPago: metodoPago,
        }));

        onFacturaPagada?.(localPaciente?._id!, localActividadId!, response.data.factura._id, response.data.factura.metodoPago?.fechaPago?.toString() ?? null, response.data.factura.estado, response.data.factura.estadoPago, localPeriodo);
        closeModalPagar();

      } catch (e: any) {
        if (e.response?.status === 401) {
          localStorage.clear();
          history(constantes.R_HOME);
        } else {
          const error: ILog = {
            method: "DetalleFacturaClase.Component.pagarFactura",
            level: "error",
            message: e.message,
            meta: e.response,
          };
          LogService.logError(error);
          setAlert({ open: true, severity: "error", msg: e.response?.data?.message || e.message });
        }
      } finally {
        setLoadingPagar(false);
      }
    };

    const emitirFactura = async () => {
      try {
        setLoadingEmitir(true);
        const response = await FacturacionService.emitirFactura(localFactura?._id!, { 
          userId: ConfigUtils.getUserId(),
          tipoPago: "clase" });

        setLocalFactura(prev => ({
          ...prev!,
          estado: "Emitida",
          numero: response.data.factura.numero,
          fechaEmision: response.data.factura.fechaEmision,
        }));

        onFacturaEmitida?.(localPaciente?._id!, localActividadId!, response.data.factura._id, response.data.factura.estado, response.data.factura.estadoPago, localPeriodo, response.data.factura.numero);
        closeModalEmitir();

      } catch (e: any) {
        if (e.response?.status === 401) {
          localStorage.clear();
          history(constantes.R_HOME);
        } else {
          const error: ILog = {
            method: "DetalleFacturaClase.Component.emitirFactura",
            level: "error",
            message: e.message,
            meta: e.response,
          };
          LogService.logError(error);
          setAlert({ open: true, severity: "error", msg: e.response?.data?.message || e.message });
        }
      } finally {
        setLoadingEmitir(false);
      }
    };

    const handleDownloadFactura = () => {
      DocUtils.formatFactura(localFactura, true, "total", undefined, undefined, esMenor ? nombreCompletoPaciente : undefined);
    };

    const handleEnviarFactura = async () => {
      try {
        setLoadingEnviar(true);
        const facturaPDF = DocUtils.formatFactura(localFactura, false, "total", undefined, undefined, esMenor ? nombreCompletoPaciente : undefined);
        const response = await FacturacionService.sendFactura({ facturaId: localFactura?._id, email: localPaciente?.email, doc: facturaPDF, nombre: localFactura?.receptor.nombre, numeroFactura: localFactura?.numero });
        setAlert({ open: true, severity: 'success', msg: response.data.message });
      } catch (e: any) {
        if (e.response.status === 401) {
              localStorage.clear();
              history(constantes.R_HOME);
          } else {
              const error: ILog = { method: 'DetalleFacturaClase.Component.sendFactura', level: 'error', message: e.message, meta: e.response };
              LogService.logError(error);
              setAlert({ open: true, severity: 'error', msg: e.response.data.message });
          }
      } finally {
        setLoadingEnviar(false);
      }
    };

    const handleSaveMotivo = async () => {
      try {
        setLoadingMotivo(true);
        const response = await FacturacionService.updateMotivoNoFacturableClase(paciente?._id!, localActividadId!, localPeriodo!, localMotivo!);
        setAlert({ open: true, severity: "success", msg: response.data.message});
        onUpdateMotivo?.(paciente?._id!, localActividadId!, localMotivo!, localPeriodo);
        setModalMotivo(false);
      } catch (e: any) {
        if (e.response?.status === 401) {
          localStorage.clear();
          history(constantes.R_HOME);
        } else {
          const error: ILog = {
            method: "DetalleFacturaClase.Component.handleSaveMotivo",
            level: "error",
            message: e.message,
            meta: e.response,
          };
          LogService.logError(error);
          setAlert({ open: true, severity: "error", msg: e.response?.data?.message || e.message });
        }
      } finally {
        setLoadingMotivo(false);
      }
    };

    const formatPeriodo = (periodo?: string) => {
      if (!periodo) return;
      const [yearPeriodo, monthPeriodo] = periodo.split("-");
      const date = new Date(Number(yearPeriodo), Number(monthPeriodo) - 1);
      return `${new Intl.DateTimeFormat("es-ES", { month: "long" }).format(date)} ${yearPeriodo}`;
    };

    const handleOpenFacturarInfo = () => {
      if (!localFactura) {
        setInfoMessage("No hay factura previa. Se creará una nueva con fecha de hoy.");
        setOpenFacturaInfo(true);
        onFacturar?.(
          localPaciente!._id!,
          localActividadId!,
          localPeriodo!
        );
        return;
      } else {
        setInfoMessage("Ya existe una factura para esta clase. Se han recuperado sus datos.");
        setOpenFacturaInfo(true);
        setIsFacturable(true);
        setModalEditarFactura(true);
      }
    };

    // Otra pantalla cambió la factura mientras esta seguía abierta: se vuelven a pedir sus datos y se muestran actualizados.
    const recargarPorCambioDeEstado = async (mensaje: string) => {
      try {
        const response = await FacturacionService.getFacturaClaseById(localFactura?._id ?? facturaId);
        setLocalFactura(response.data.factura);
        setLocalPaciente(response.data.paciente);
        setLocalActividadId(response.data.actividadId);
        setLocalPeriodo(response.data.periodo);
        onEstadoCambiado?.(response.data.paciente._id, response.data.actividadId, response.data.periodo, response.data.factura);
        setAlert({ open: true, severity: 'warning', msg: mensaje });
      } catch (e: any) {
        setAlert({ open: true, severity: 'error', msg: e.response?.data?.message || e.message });
      }
    };

    const handleAnularFactura = async () => {
      try {
        setLoadingAnular(true);
        const response = await FacturacionService.anularFactura(localFactura?._id!, { motivoAnulacion, tipoPago: "total", estadoEsperado: localFactura?.estado });
        setAlert({ open: true, severity: 'success', msg: response.data.message });
        setModalAnular(false);
        setMotivoAnulacion("");
        onAnularFactura?.(localPaciente?._id!, localActividadId!, localPeriodo!, localFactura?._id!, motivoAnulacion, response.data.factura);
        setLocalFactura(prev => {
          if (!prev) return prev;
          return {
            ...prev,
            estado: "Anulada"
          } as IFacturaCompleta
        })
      } catch (e: any) {
        if (e.response?.status === 409) {
          setModalAnular(false);
          setMotivoAnulacion("");
          await recargarPorCambioDeEstado(e.response.data.message);
        } else if (e.response.status === 401) {
              localStorage.clear();
              history(constantes.R_HOME);
          } else {
              const error: ILog = { method: 'DetalleFacturaClase.Component.anularFactura', level: 'error', message: e.message, meta: e.response };
              LogService.logError(error);
              setAlert({ open: true, severity: 'error', msg: e.response.data.message });
          }
      } finally {
        setLoadingAnular(false);
      }
    };

    const handleCambiarEntidad = async (nuevaEntidadId: string | null) => {
      try {
        setLoadingCambiarEntidad(true);
        const response = await FacturacionService.cambiarEntidadFactura(localFactura!._id, {
          userId: ConfigUtils.getUserId(),
          entidadNuevaId: nuevaEntidadId,
          estadoEsperado: localFactura!.estado,
        });
        // Se sustituye por la factura nueva completa (no se fusiona): no trae número ni fecha de emisión, y al fusionar
        // se conservarían los de la factura anulada.
        const facturaNueva = response.data.factura as IFacturaCompleta;
        onEntidadCambiada?.(localPaciente?._id!, localActividadId!, localPeriodo!, localFactura!._id, facturaNueva, response.data.anulacion);
        setLocalFactura(facturaNueva);
        setModalCambiarEntidad(false);
        setAlert({ open: true, severity: 'success', msg: 'Entidad de facturación cambiada correctamente' });
      } catch (e: any) {
        if (e.response?.status === 409) {
          setModalCambiarEntidad(false);
          await recargarPorCambioDeEstado(e.response.data.message);
        } else if (e.response?.status === 401) {
          localStorage.clear();
          history(constantes.R_HOME);
        } else {
          const error: ILog = { method: 'DetalleFacturaClase.Component.cambiarEntidad', level: 'error', message: e.message, meta: e.response };
          LogService.logError(error);
          setAlert({ open: true, severity: 'error', msg: e.response?.data?.message || e.message });
        }
      } finally {
        setLoadingCambiarEntidad(false);
      }
    };

    const actividadTitle = actividades.find(a => Number(a.internalID) === localActividadId)?.title;
    const edad = localPaciente?.fechaNacimiento
      ? PacientesUtils.calcularEdad(localPaciente?.fechaNacimiento)
      : null;

    const esMenor = edad !== null && edad !== undefined && edad < 18;

    const nombreCompletoPaciente = `${localPaciente?.nombre} ${localPaciente?.apellidos ?? ""}`.trim();

    const pacienteMenor = esMenor ? nombreCompletoPaciente : undefined;
    const missingFields = [
        !localPaciente?.domicilio ? "Dirección" : null,
        !localPaciente?.fechaNacimiento ? "Fecha de Nacimiento" : null,

        esMenor
          ? !localPaciente?.DNItutor
            ? "DNI del tutor"
            : null
          : !localPaciente?.DNI
            ? "DNI"
            : null,
    ].filter((f): f is string => Boolean(f));

    const receptor = localFactura?.receptor ?? {
      nombre: localPaciente?.nombre,
      email: localPaciente?.email,
      direccion: localPaciente?.domicilio,
      nif: esMenor ? localPaciente?.DNItutor : localPaciente?.DNI
    };

    const facturableState = localFactura ? !!localFactura.activo : isFacturable;

    const { isDisabledEmail, tooltipMsg } = PacientesUtils.canSendFactura(
      loadingEnviar,
      localPaciente?.authEmail,
      localPaciente?.email,
      localFactura?.estado,
      localFactura?.facturaRectificadaId
    );
    
    return (
        <>
        <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
            {loading ? <CircularProgress style={{ margin: "20px auto" }} /> : 
            <>
              <Box sx={{ p: 2, backgroundColor: "#f8f9fa", border: "1px solid #e5e5e5" }}>
              {/* Aviso de datos incompletos */}
              {missingFields.length > 0 && showMissingAlert && localFactura && localFactura.estado !== "Emitida" && (
              <Alert
                severity="warning"
                sx={{ mb: 1, fontSize: "0.875rem" }}
                onClose={() => setShowMissingAlert(false)}
              >
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="body2">
                    Faltan datos importantes: <b>{missingFields.join(", ")}</b>.
                  </Typography>
              
                  <Button
                    size="small"
                    color="warning"
                    onClick={() => history(constantes.R_NUEVOPACIENTE, { state: localPaciente })}
                  >
                    Editar
                  </Button>
                </Box>
              </Alert>
              )}

              {/* Emisor — solo si hay más de una entidad de facturación configurada */}
              {localFactura?.emisor && ConfigUtils.getDatosFacturacionAdicional().length > 0 && (
                <Box display="flex" alignItems="center" gap={0.5} mb={1.5} pb={1} sx={{ borderBottom: "1px solid #e5e5e5" }}>
                  <Typography variant="body2" color="text.secondary">
                    <b>Entidad emisora:</b> {localFactura.emisor.razonSocial}
                  </Typography>
                  {userRole === constantes.ROLES.ADMINISTRADOR && localFactura.estado !== 'Anulada' && !localFactura.facturaOriginalId && !localFactura.facturaRectificadaId && !localFactura.bonoId && (
                    <Tooltip title="Cambiar entidad de facturación">
                      <IconButton size="small" onClick={() => setModalCambiarEntidad(true)}>
                        <EditIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              )}

              <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} justifyContent="space-between">
                {/* Datos del receptor */}
                <Box flex={1}>
                  <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>
                    Receptor
                  </Typography>
                  {pacienteMenor && <Typography variant="body2">
                    <b>Paciente:</b> {pacienteMenor}
                </Typography>}           
                  <Typography variant="body2">
                    <b>Nombre:</b> {receptor.nombre}
                  </Typography>           
                  {receptor.nif && (
                    <Typography variant="body2">
                      <b>DNI:</b> {receptor.nif}
                    </Typography>
                  )}                    
                  {receptor.email && (
                    <Typography variant="body2">
                      <b>Email:</b> {receptor.email}
                    </Typography>
                  )}
                  {receptor.direccion && (
                    <Typography variant="body2">
                      <b>Domicilio:</b> {receptor.direccion}
                    </Typography>
                  )}
                </Box>

                <Box flexShrink={0} mt={{ xs: 2, sm: 0 }}>
                    <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>
                      {actividadTitle}
                    </Typography>

                    <Typography variant="body2">
                      {formatPeriodo(localPeriodo)}
                    </Typography>
                  </Box>
              </Box>

              </Box>
              {localFactura && facturableState && <DialogContent>
                  <Box mb={isMobile ? 2 : 3}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      gap={2}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600 }}
                      >
                        Información de la factura
                      </Typography>       
                      {/* Acciones */}
                      <Box display="flex" gap={0.5}>
                        <Tooltip title="Descargar factura">
                          <IconButton
                            size="small"
                            onClick={handleDownloadFactura}
                          >
                            <DownloadIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={localFactura.estado === "Anulada" ? "Factura anulada" : tooltipMsg}>
                          <span>
                            <IconButton
                              size="small"
                              onClick={handleEnviarFactura}
                              disabled={isDisabledEmail || localFactura.estado === "Anulada"}
                            >
                              {loadingEnviar ? <CircularProgress size={18} /> : <EmailIcon fontSize="small" />}
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    </Box>        
                        
                    <Box mb={1}>
                      {/* --- Fila principal: Nº, Fecha, Estado --- */}
                      <Stack
                        direction={isMobile ? "column" : "row"}
                        justifyContent="flex-start"
                        alignItems={isMobile ? "flex-start" : "center"}
                        spacing={isMobile ? 1 : 2}
                      >
                        {/* Nº */}
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 120 }}>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            Nº
                          </Typography>
                          <Typography variant="body2">{formatNumeroFactura(localFactura.numero)}</Typography>
                        </Stack>

                        {/* Fecha */}
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 120 }}>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            Fecha
                          </Typography>
                          <Typography variant="body2">{new Date(localFactura.fechaFactura!).toLocaleDateString()}</Typography>
                        </Stack>

                        {/* Estado */}
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 140 }}>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            Estado
                          </Typography>
                          {localFactura.estado === "Anulada" ? (
                            <Tooltip
                              title={localFactura?.motivoAnulacion}
                              placement="top"
                              arrow
                            >
                              <Chip
                                label={localFactura.estado}
                                size="small"
                                sx={{ textTransform: "capitalize", border: `1px solid #d32f2f`, color: "#d32f2f" }}
                              />
                            </Tooltip>
                          ) : (
                            <Chip
                              {...chipEstadoFactura(localFactura)}
                              size="small"
                              sx={{ textTransform: "capitalize" }}
                            />
                          )}
                        </Stack>
                      </Stack>

                      {/* --- Fila final: Información de rectificación --- */}
                      {(localFactura.facturaOriginalId || localFactura.facturaRectificadaId) && (
                        <Stack direction="column" spacing={0.5} sx={{ mt: 0.5 }}>
                          {localFactura.facturaOriginalId && (
                            <Stack direction="row" spacing={1}>
                              <Typography variant="body2" sx={{ fontStyle: "italic", color: "text.secondary" }}>
                                {localFactura?.tipoRectificacion === "anulacion" ? "Anulación de la factura nº" : "Rectificativa de la factura nº"}
                              </Typography>
                              <EnlaceFactura facturaId={localFactura.facturaOriginalRef} numero={localFactura.facturaOriginalId} cursiva />
                            </Stack>
                          )}
                          {localFactura.facturaRectificadaId && (
                            <Stack direction="row" spacing={1}>
                              <Typography variant="body2" sx={{ fontStyle: "italic", color: "text.secondary" }}>
                                {localFactura?.estado === "Anulada" ? "Anulada por la factura nº" : "Rectificada por la factura nº"}
                              </Typography>
                              <EnlaceFactura facturaId={localFactura.facturaRectificadaId} numero={localFactura.facturaRectificada} cursiva />
                            </Stack>
                          )}
                        </Stack>
                      )}
                    </Box>

                  </Box>
                  <Divider sx={{ mb: 2 }} />
                  <Box
                    display="flex"
                    flexDirection={isMobile ? "column" : "row"}
                    justifyContent="space-between"
                    alignItems={isMobile ? "stretch" : "center"}
                    mb={2}
                    gap={isMobile ? 1.5 : 4}
                  >
                    {/* INFO IZQUIERDA */}
                    <Box display="flex" flexDirection="column" gap={isMobile ? 0.75 : 1}>
                      {/* Estado de pago */}
                      <Box display="flex" justifyContent="space-between" alignItems="center" gap={{ xs: 0, sm: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          Estado
                        </Typography>
                        <Chip
                          {...chipEstadoPago(localFactura)}
                          size="small"
                        />
                      </Box>
                    
                      {/* Tipo de facturación */}
                      <Box display="flex" justifyContent="space-between" alignItems="center" gap={{ xs: 0, sm: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          Tipo
                        </Typography>
                        <Chip
                          label={"Total"}
                          size="small"
                          color="info"
                        />
                      </Box>
                    
                      {/* Servicio */}
                      <Box display="flex" justifyContent="space-between" gap={{ xs: 0, sm: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          Servicio
                        </Typography>
                        <Typography variant="body2" noWrap>
                          {localFactura.servicio}
                        </Typography>
                      </Box>
                    </Box>
                    
                    {/* IMPORTE */}
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems={isMobile ? "flex-start" : "flex-end"}
                      mt={isMobile ? 1 : 0}
                    >
                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        Importe
                      </Typography>
                      <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                        {formatCurrency(Number(localFactura.importeTotal), monedaFactura)}
                      </Typography>
                    </Box>
                  </Box>
                  {/* Si la factura está pagada, método de pago */}
                  {localFactura.estadoPago === "Pagada" && (
                  <Box
                    mb={3}
                    p={2}
                    sx={{
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 2,
                      backgroundColor: "background.paper",
                      maxWidth: 400,
                    }}
                  >
                    <Box display="flex" flexDirection="column" gap={0.5}>
                      <Typography variant="body2">
                        <b>Método de pago:</b> {localFactura.metodoPago?.nombre}
                      </Typography>
                      <Typography variant="body2">
                        <b>Fecha de pago:</b> {moment(localFactura.metodoPago?.fechaPago).format('DD/MM/YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                  )}
                  <Divider />
                  <Box mt={2} display="flex" justifyContent="space-between">
                    <Button 
                      variant="outlined" 
                      size="small" 
                      onClick={() => setExpandirDetalle(!expandirDetalle)}
                    >
                      {expandirDetalle ? "Ocultar detalles" : "Ver detalles"}
                    </Button>

                    <Box display="flex" gap={1} alignItems="center">

                    {acciones.mostrarBotonesAccion && (
                      <ButtonGroup variant="outlined" color="success">
                        {acciones.mostrarPagar && (
                          <Button variant={acciones.variantPagar} onClick={openModalPagar}>Pagar</Button>
                        )}
                        {acciones.mostrarEmitir && (
                          <Button variant={acciones.variantEmitir} onClick={openModalEmitir}>Emitir</Button>
                        )}
                      </ButtonGroup>
                    )}
                    <EliminarFacturaAnulada factura={localFactura} onEliminada={(aviso) => { onFacturaEliminada?.(localPaciente?._id!, localActividadId!, localPeriodo!, localFactura!._id, aviso); onClose(); }} />
                    {userRole === constantes.ROLES.ADMINISTRADOR &&
                    acciones.mostrarMenuAcciones && (
                      <>
                        <Tooltip title="Más acciones">
                          <IconButton
                            size="small"
                            onClick={(e) => setAnchorEl(e.currentTarget)}
                          >
                            <MoreIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={() => setAnchorEl(null)}
                        >
                          {acciones.mostrarCorregirCobro && <MenuItem
                            onClick={() => {
                              setAnchorEl(null);
                              openModalPagar();
                            }}
                          >
                            <ListItemText>
                              Corregir cobro
                            </ListItemText>
                          </MenuItem>}
                          {acciones.mostrarRectificar && <MenuItem
                            onClick={() => {
                              setAnchorEl(null);
                              setFacturaRectificar(localFactura);
                            }}
                          >
                            <ListItemText>
                              Rectificar factura
                            </ListItemText>
                          </MenuItem>}

                          <MenuItem
                            key="menu-anular"
                            onClick={() => {
                              setAnchorEl(null);
                              setModalAnular(true);
                            }}
                          >
                            <ListItemText>
                              Anular factura
                            </ListItemText>
                          </MenuItem>
                        </Menu>
                      </>
                  )}
                  </Box>
                  </Box>
                  {/* Bloque expandible */}
                  <Collapse in={expandirDetalle} timeout="auto" unmountOnExit>
                    <Box
                      mt={2}
                      p={2}
                      sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                        backgroundColor: "background.paper",
                        overflowX: "auto",
                      }}
                    >
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
                        Detalle de conceptos
                      </Typography>
                    
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Concepto</TableCell>
                            <TableCell align="right">Cantidad</TableCell>
                            <TableCell align="right">Precio unit.</TableCell>
                            <TableCell align="right">Subtotal</TableCell>
                          </TableRow>
                        </TableHead>
                    
                        <TableBody>
                          {localFactura.conceptos.map((c: IConcepto, index: number) => {
                            const imp = localFactura.impuestos?.[index];
                            const base = c.cantidad * c.precio;
                            const cuota = imp ? base * (imp.cuota / 100) : 0;
                            const total = base + cuota;
                          
                            return (
                              <React.Fragment key={index}>
                                {/* LÍNEA PRINCIPAL */}
                                <TableRow hover>
                                  <TableCell>{c.nombre}</TableCell>
                                  <TableCell align="right">{c.cantidad}</TableCell>
                                  <TableCell align="right">
                                    {formatCurrency(c.precio, monedaFactura)}
                                  </TableCell>
                                  <TableCell align="right">
                                    {formatCurrency(base, monedaFactura)}
                                  </TableCell>
                                </TableRow>
                            
                                {/* LÍNEA DETALLE: IMPUESTO + TOTAL */}
                                {imp && (
                                  <TableRow>
                                    <TableCell
                                      colSpan={4}
                                      sx={{
                                        pl: 6,
                                        py: 0.8,
                                        backgroundColor: "action.hover",
                                        borderBottom: "none",
                                      }}
                                    >
                                      <Typography variant="body2" color="text.secondary">
                                        {imp.tipo} ({imp.cuota}%): {formatCurrency(cuota, monedaFactura)}
                                        &nbsp;•&nbsp;
                                        <strong>Total: {formatCurrency(total, monedaFactura)}</strong>
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Box>
                  </Collapse>
              </DialogContent>}
              {!facturableState && <DialogContent>
              <Box
                sx={{
                  p: 1,
                  mb: 1,
                }}
              >
                  <Typography variant="h6" sx={{ mb: 1 }}>
                    Este paciente está marcado como <b>NO facturable</b> este mes
                  </Typography>
                  {localMotivo ? (
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Motivo:</strong> {localMotivo}
                    </Typography>
                  ) : (
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      No se ha especificado motivo.
                    </Typography>
                  )}
                  <Button
                    size="small"
                    variant="text"
                    startIcon={<EditIcon fontSize="small" />}
                    onClick={() => setModalMotivo(true)}
                    sx={{
                      textTransform: "none",
                      fontSize: "0.8rem",
                      minWidth: "auto",
                      px: 1,
                      color: "text.secondary",
                      "&:hover": {
                        backgroundColor: "transparent",
                        textDecoration: "underline",
                      },
                    }}
                  >
                   {!localMotivo ? "Añadir motivo" : "Editar motivo"}
                  </Button>
                  <Alert 
                    severity="info"
                    icon={<InfoIcon />}
                    sx={{
                      mt: 1,
                      fontSize: "0.9rem",
                      backgroundColor: "#f0f4ff",
                      borderRadius: 1,
                    }}
                  >
                    Puedes editar la facturación de este mes para volver a marcarlo como facturable.
                  </Alert>
              </Box>
              </DialogContent>}
              <DialogActions>
                <Button onClick={onClose}>
                  Cerrar
                </Button>
                {localFactura?.estado !== "Emitida" && 
                <Button 
                  size="small" 
                  color="primary" 
                  variant="contained" 
                  onClick={() => facturableState ? setModalEditarFactura(true) : handleOpenFacturarInfo()}
                  disabled={localFactura?.estado === "Anulada"}
                >
                  {localFactura ? "Editar" : "Facturar"}
                </Button>}  
              </DialogActions>
            </>
            }
        </Dialog>

        {modalEditarFactura &&
        <EditarFacturaClaseForm
          open={modalEditarFactura}
          onClose={() => {setModalEditarFactura(false); setIsFacturable(localFactura?.activo!) }}
          paciente={localPaciente!}
          factura={localFactura!}
          onSuccess={(pacienteId, actividadId, { result, factura, estado, motivo }) => {
            if (factura) {
              setLocalFactura({ ...factura });
            };
            setLocalMotivo(motivo);
            onEdit?.(pacienteId, actividadId, factura, estado, motivo, localPeriodo);
            if (estado === "NO_FACTURABLE_PUNTUAL") {
              setIsFacturable(false);
            }
          }}
          facturableProp={isFacturable}
          motivoNoFacturable={motivoNoFacturable}
          actividad={actividadTitle!}
          periodo={formatPeriodo(localPeriodo)!}
        />}

        {/* Modal pagar */}
        {modalPagar &&
        <Dialog open={modalPagar} onClose={loadingPagar ? undefined : closeModalPagar} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ fontSize: "1.3rem", fontWeight: "bold" }}>
            {localFactura?.estadoPago === "Pagada" ? "Corregir cobro" : "Pagar factura"}
          </DialogTitle>
          <DialogContent sx={{ pt: 1 }}>
            {/* Importe total */}
            <Box
              sx={{
                mb: 3,
                mt: 1,
                p: 2,
                borderRadius: 2,
                bgcolor: "grey.100",
                textAlign: "center"
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: "bold", color: "success.main" }}>
                {formatCurrency(Number(localFactura?.importeTotal), monedaFactura)}
              </Typography>
            </Box>
            
            {/* Método de pago */}
            <FormControl fullWidth error={!!errorMetodoPago}>
              <InputLabel id="metodo-pago-label">Método de pago*</InputLabel>
              <Select
                labelId="metodo-pago-label"
                label="Método de pago*"
                value={metodoPago?.nombre || ""}
                onChange={(e) => {
                  const nombre = e.target.value;
                  const codigo = metodosPago.find((m) => m.nombre === nombre)?.codigo!;
                  setMetodoPago({ nombre, codigo, fechaPago: moment() });
                  setErrorMetodoPago(undefined);
                }}
              >
                {metodosPago
                  .filter((m) => m.activo)
                  .map((m) => (
                    <MenuItem key={m.codigo} value={m.nombre}>
                      {m.nombre}
                    </MenuItem>
                  ))}
              </Select>
                
              {errorMetodoPago && (
                <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
                  {errorMetodoPago}
                </Typography>
              )}
            </FormControl>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                label="Fecha de pago"
                value={metodoPago?.fechaPago}
                onChange={(date) => {
                  if (metodoPago) {
                    setMetodoPago({ ...metodoPago, fechaPago: date ?? moment() });
                    setErrorFechaPago(undefined);
                  }
                }}
                renderInput={(params) => <TextField required fullWidth sx={{ mt: 2 }} error={!!errorFechaPago} helperText={errorFechaPago} {...params} />}
              />
            </LocalizationProvider>
          </DialogContent>              
          <DialogActions sx={{ p: 2 }}>
            <Button 
              variant="contained" 
              color="success"
              onClick={pagarFactura}
              disabled={loadingPagar}
              startIcon={loadingPagar && <CircularProgress size={18} />}
            >
              Pagar
            </Button>
              
            <Button 
              variant="outlined" 
              color="inherit"
              onClick={closeModalPagar}
              disabled={loadingPagar}
            >
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>}
        {/* Modal emitir */}
        {modalEmitir && 
        <Dialog open={modalEmitir} onClose={loadingEmitir ? undefined : closeModalEmitir} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ fontSize: "1.3rem", fontWeight: "bold" }}>Emitir factura</DialogTitle>
          <DialogContent sx={{ pt: 1 }}>
            {erroresPaciente.length > 0 ? (
              <Alert severity="error" sx={{ mt: 2 }}>
                No se puede emitir la factura. Faltan datos importantes:
                <ul>
                  {erroresPaciente.map((e) => (
                    <li key={e}>{e}</li>
                  ))}
                </ul>
              </Alert>
            ) : 
            <>
            <Alert severity="warning" sx={{ mb: 2 }}>
              {!localFactura?.receptor?.direccion && (
                <>La factura se emitirá sin dirección del paciente.<br /><br /></>
              )}
              Una vez emitida, la factura no se podrá modificar.
              Solo se podrá generar una factura rectificativa.
            </Alert>

            <NumeroOrientativoEmision info={numeroOrientativo} />


            <Typography>
              ¿Deseas emitir esta factura definitivamente?
            </Typography>
            </>
            }

          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            {erroresPaciente.length === 0 ? (
              <>
                <Button 
                  variant="contained" 
                  color="success"
                  onClick={emitirFactura}
                  disabled={loadingEmitir}
                  startIcon={loadingEmitir && <CircularProgress size={18} />}
                >
                  Emitir
                </Button>
            
                <Button 
                  variant="outlined" 
                  color="inherit"
                  onClick={closeModalEmitir}
                  disabled={loadingEmitir}
                >
                  Cancelar
                </Button>
              </>
            ) : (
              <Button 
                variant="outlined" 
                color="inherit"
                onClick={closeModalEmitir}
              >
                Cerrar
              </Button>
            )}
          </DialogActions>
        </Dialog>}

        {/* Modal motivo no facturable */}
        {modalMotivo &&
        <Dialog open={open} onClose={closeModalMotivo} fullWidth maxWidth="xs">
          <DialogTitle>{!motivoNoFacturable ? "Añadir motivo" : "Editar motivo"}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              fullWidth
              multiline
              minRows={2}
              label="Motivo no facturable"
              value={localMotivo}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setLocalMotivo(e.target.value)}
              sx={{ mt: 1 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={closeModalMotivo}>Cancelar</Button>
            <Button
              onClick={handleSaveMotivo}
              variant="contained"
              disabled={loadingMotivo}
            >
              Guardar
            </Button>
          </DialogActions>
        </Dialog>}

        <Dialog open={openFacturaInfo} onClose={() => setOpenFacturaInfo(false)}>
          <DialogTitle>Aviso</DialogTitle>      

          <DialogContent dividers>
            <Typography>{infoMessage}</Typography>
          </DialogContent>      

          <DialogActions>
            <Button variant="contained" onClick={() => setOpenFacturaInfo(false)}>
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        {facturaRectificar !== null &&
        <RectificarFacturaClase 
          factura={facturaRectificar}
          pacienteId={localPaciente?._id!}
          open={!!facturaRectificar}
          onClose={() => setFacturaRectificar(null)}
          onFacturaRectificada={(facturaRectificativa: IFacturaCompleta) => {
            setLocalFactura(prev => {
              if (!prev) return prev;
            
              return {
                ...prev,
                facturaRectificada: facturaRectificativa.numero,
                facturaRectificadaId: facturaRectificativa._id
              };
            });
            if (onFacturaRectificada) onFacturaRectificada(localPaciente?._id!, localActividadId!, facturaRectificativa, localPeriodo);
          }}
        />
        }

        {/* Modal cambiar entidad */}
        {modalCambiarEntidad && (
          <CambiarEntidadDialog
            open={modalCambiarEntidad}
            onClose={() => setModalCambiarEntidad(false)}
            entidadActualId={localFactura?.entityId ?? null}
            esBorrador={localFactura?.estado === "Borrador"}
            loading={loadingCambiarEntidad}
            onConfirm={handleCambiarEntidad}
          />
        )}

        {/* Modal anular */}
        {modalAnular &&
        <AnularFacturaDialog
          open={modalAnular}
          loading={loadingAnular}
          numero={localFactura?.numero}
          esBorrador={localFactura?.estado === "Borrador"}
          esRectificativa={!!localFactura?.facturaOriginalId}
          motivo={motivoAnulacion}
          onMotivoChange={setMotivoAnulacion}
          confirmar={confirmarAnulacion}
          onConfirmarChange={setConfirmarAnulacion}
          onClose={() => setModalAnular(false)}
          onConfirm={handleAnularFactura}
        />}

        <Snackbar open={alert.open} autoHideDuration={6000} onClose={handleCloseAlert}>
          <Alert variant="filled"  onClose={handleCloseAlert} severity={alert.severity} sx={{ width: "100%" }}>
            {alert.msg}
          </Alert>
        </Snackbar>
        </>
    );
};

export default DetalleFacturaClase;